export default "__VITE_PUBLIC_ASSET__abb2669e__"